import React from 'react';
import { Segment, Table, Header, Icon, Popup } from 'semantic-ui-react';
import { IconHeader } from '../util/css';

/**
    props: switchToTable (function), equipment (Object)
*/

export default class PremisesDetails extends React.Component {
    getOrganizationalUnitPropertyName(organizationalUnitProperty) {
        return organizationalUnitProperty.text;
    }

    render() {
        const { room } = this.props;
        return (
            <div>
                <Header as="h1">Prostorije</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            O prostoriji
                            <Header style={IconHeader} floated="right">
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic floated="right" name="arrow left" onClick={this.props.switchToTable} />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                        </Header>
                    </Segment>
                    <Segment>
                        <Table celled>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Naziv</b></Table.Cell>
                                    <Table.Cell textAlign="center">{room.name}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Kod</b></Table.Cell>
                                    <Table.Cell textAlign="center">{room.code}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Tip</b></Table.Cell>
                                    <Table.Cell textAlign="center">{!!room.roomType && room.roomType.name}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Sprat</b></Table.Cell>
                                    <Table.Cell textAlign="center">{room.floor}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Površina (m<sup>2</sup>)</b></Table.Cell>
                                    <Table.Cell textAlign="center">{room.area}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Pristup invalidima</b></Table.Cell>
                                    <Table.Cell textAlign="center">{!!room.disabledAccess && room.disabledAccess.name}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Broj mjesta</b></Table.Cell>
                                    <Table.Cell textAlign="center">{room.seatCapacity}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="center"><b>Broj mjesta za ispit</b></Table.Cell>
                                    <Table.Cell textAlign="center">{room.examSeatCapacity}</Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </Segment>

                    <Segment>
                        <Header as="h3">Organizaciona jedinica - Imovina</Header>
                        <Table compact>
                            <Table.Body>
                                {this.props.organizationalUnitProperties.map(el =>
                                    (<Table.Row key={el.id}>
                                        <Table.Cell>
                                            {this.getOrganizationalUnitPropertyName(el)}
                                        </Table.Cell>
                                    </Table.Row>))}
                            </Table.Body>
                        </Table>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Premises/PremisesDetails.js